module.exports = "<button class=\"btn btn-default\" (click)=\"downloadResponses()\">{{title}}</button>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-download-response/ipp-download-response.component.html
// module id = mZgk
// module chunks = 1